<template>
    <label class="text-sm block text-cavilam-primary font-semibold" :for="name">
        {{ __(libelle) }} <sup v-if="required" class="text-red-500">*</sup>
    </label>
    <input
       @change="$parent.form[name] = $event.target.files[0]"
       :class="{'border-red-500':$parent.form.errors[name]}"
       class="w-full py-2 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:font-semibold file:bg-cavilam-primary/20 file:text-cavilam-primary hover:file:bg-cavilam-primary/50"
       type="file"
       :id="name"
       :name="name"
       :accept="accept"
       >
    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors[name]}">
        {{ __($parent.form.errors[name]) }}
    </p>
</template>

<script>
export default {
    name: "InputFile",
    props: {
        name: {
            type: String,
            required: true
        },
        libelle: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: ""
        },
    },
}
</script>

<style scoped>

</style>
